/**
 * A util function to convert numbers to more comma style format
 * e.g. `12342353` => `12,342,353`
 * e.g. `123` => `123`
 * e.g. `12` => `12`
 * @param  {String} string or number
 * @return {string} formatted string
 */
export const commaStyleString = (number, separator) => {
  separator = typeof separator === 'undefined' ? ',' : '' + separator

  // Convert to number if it's a non-numeric value
  if (typeof number !== 'number') {
    number = Number(number)
  }

  // NaN => 0
  if (isNaN(number)) {
    number = 0
  }

  // Return Infinity immediately
  if (!isFinite(number)) {
    return '' + number
  }

  let stringNumber = ('' + Math.abs(number)).split('').reverse()

  let result = []
  for (var i = 0; i < stringNumber.length; i++) {
    if (i && i % 3 === 0) {
      result.push(separator)
    }
    result.push(stringNumber[i])
  }

  // Handle negative numbers
  if (number < 0) {
    result.push('-')
  }

  return result.reverse().join('')
}

/**
 * Convert key-text to be more attractive as a title
 * eg. 'blog-magazine' => 'Blog Magazine'
 *     'blog magazine' => 'Blog Magazine'
 * @param {String} text
 * @returns {String}
 */
export const toTitle = key => {
  if (!key) {
    return ''
  }
  return key
    .split(/-|_/)
    .join(' ')
    .replace(/\b\w/g, l => l.toUpperCase())
}

/**
 * $10.00 should be $10
 * $10.15 should be $10.15
 */
export const centlessFormat = data => {
  const absValue = Math.abs(data)
  const isInt = n => n % 1 === 0
  return isInt(absValue) ? parseInt(absValue) : absValue.toFixed(2)
}

/**
 * get price variation
 * $12.12 - $5.00
 * should return a centless formatted value
 */
export const getPriceVariation = (currentPrice, upgradePrice) => {
  const intPrice = priceString => parseFloat(priceString.replace('$', ''))
  const variation = intPrice(upgradePrice) - intPrice(currentPrice)
  if (variation === 0) return ''
  let variationType = variation > 0 ? '+' : '-'
  return `${variationType}$${centlessFormat(variation)}`
}

/**
 * shorten number
 * 12.2K
 * returns shorten to thousands number
 * @param  {String} string or number
 * @return {string} formatted string
 */

export const shortenNumber = number => {
  number = Number(number)
  let suffix = ''

  if (isNaN(number) || number == 0) {
    return ''
  } else if (number >= 1e6) {
    suffix = 'M'
    number = number / 1e6
  } else if (number >= 1e3) {
    suffix = 'K'
    number = number / 1e3
  }

  return `${Math.round(number * 10) / 10}${suffix}`
}

export function formatNumberWithCommas(number) {
  if (typeof number === 'number') {
    return formatNumberWithCommas(number.toString())
  } else if (typeof number === 'string') {
    return number.replace(/ /g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  } else {
    return number
  }
}
